import React,{useState, useEffect} from 'react'
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBCardTitle,
    MDBCardText,
    MDBCol,
    MDBListGroupItem
} from 'mdbreact';
import {Trans} from "react-i18next";
import classes from './TipCard.module.css'

const TipCard = (props) => {
    return(
        <MDBCard style={{ width: "22rem" }} className={classes.TipCard}>
            <MDBCardImage className={["img-fluid", classes.CardImage].join(" ")} src={props.data.imageUrl} waves />
            <MDBCardBody>
                <MDBCardTitle className={classes.CardTitle}>
                    <a href={props.data.url} target={'_blank'}  rel="noreferrer">
                    {props.data.title}
                    </a>
                </MDBCardTitle>
                <MDBCardText className={classes.Description}>
                    {props.data.description}
                </MDBCardText>
                <div className={classes.Source}>
                    <Trans>TipCard.source</Trans> : {props.data.sourceName}
                </div>
                <a href={props.data.url} target={'_blank'}  rel={"noreferrer"+ (props.data.doFollow ? "" :" nofollow") } className={classes.UrlBtn}>
                    <Trans>TipCard.go</Trans>
                </a>
            </MDBCardBody>
        </MDBCard>
    )
}
export default TipCard